"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyServiceStub = void 0;
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const mystake_validator_public_1 = require("@boulevard1/mystake-validator-public");
const faker = __importStar(require("faker"));
const moment_1 = __importDefault(require("moment"));
const OptionGrantType_1 = require("../contracts/options/OptionGrantType");
const enums_1 = require("../enums");
const fakeCompanyInfo = {
    _id: faker.random.uuid(),
    name: faker.fake("{{company.companyName}} {{company.companySuffix}}"),
    acn: faker.random.number().toString(),
    abn: faker.random.number().toString(),
    tfn: faker.random.number().toString(),
    registeredAddress: faker.random.uuid(),
    principalPlaceOfBusinessAddress: faker.random.uuid(),
    companyType: faker.random.arrayElement(),
    shareholderType: faker.random.arrayElement(),
    tncAccepted: faker.random.boolean(),
    kycAuthorization: {
        hasNominated: faker.random.boolean(),
        nomineeId: faker.random.uuid(),
        dateOfNomination: faker.date.recent(),
        nomineeToken: faker.random.alphaNumeric(),
    },
    status: [
        mystake_common_sdk_1.CompanyListItemStatus.ReadyForReview,
        mystake_common_sdk_1.CompanyListItemStatus.KYCPending,
        mystake_common_sdk_1.CompanyListItemStatus.SetUpInProgress,
        mystake_common_sdk_1.CompanyListItemStatus.AddPaymentMethod,
    ][faker.random.number({ min: 0, max: 3 })],
    stripeData: {
        customerId: faker.random.uuid(),
        selectedPriceId: faker.random.uuid(),
        subscriptionId: faker.random.uuid(),
        selectedSubscriptionPlan: faker.random.word(),
    },
    isAsicConnectionActivated: faker.random.boolean(),
    primaryAdminId: faker.random.uuid(),
    displayName: "",
    displayLogo: "",
    shareCertificateConfig: {
        enableShareCertificates: true,
        prefix: "ABC",
        startNumber: 10,
        officeholders: [{ _id: faker.random.uuid(), fontFamily: null }],
    },
};
const fakeUserProfile = {
    _id: faker.random.uuid(),
    salutation: faker.name.prefix(),
    familyName: faker.name.lastName(),
    firstName: faker.name.lastName(),
    emails: [
        {
            email: faker.internet.email(),
            isPrimary: faker.random.boolean(),
            isVerified: faker.random.boolean(),
        },
    ],
    phones: [
        {
            iso2: faker.address.countryCode(),
            dialCode: faker.phone.phoneNumber(),
            phoneNumber: faker.phone.phoneNumber(),
            isPrimary: faker.random.boolean(),
            isVerified: faker.random.boolean(),
        },
    ],
    username: faker.random.uuid(),
    birthDetails: {
        dob: faker.date.past(20),
        birthPlace: faker.address.city(),
        birthCountry: faker.address.country(),
    },
    kycDetails: {
        isKYCDone: faker.random.boolean(),
        address: {
            // flatNumber: faker.address.secondaryAddress(),
            description: "987/12345 Street St, Qld, AU",
            flatNumber: "987",
            streetNumber: "12345",
            streetName: faker.address.streetName(),
            suburb: faker.address.city(),
            postcode: faker.address.zipCode(),
            // state: faker.address.state(),
            state: "QLD",
            // country: faker.address.country(),
            country: "AU",
        },
        verificationId: "",
        verificationToken: "",
    },
    companyIds: faker.random.boolean() ? [faker.random.uuid()] : [faker.random.uuid(), faker.random.uuid()],
    onboardingStatus: [
        mystake_common_sdk_1.CompanyListItemStatus.ReadyForReview,
        mystake_common_sdk_1.CompanyListItemStatus.KYCPending,
        mystake_common_sdk_1.CompanyListItemStatus.SetUpInProgress,
        mystake_common_sdk_1.CompanyListItemStatus.AddPaymentMethod,
    ][faker.random.number({ min: 0, max: 3 })],
    isInvestor: faker.random.boolean(),
    isExternalInvestor: faker.random.boolean(),
    roles: [mystake_common_sdk_1.Roles.ADMIN],
    rolesByCompany: [
        {
            companyId: faker.random.uuid(),
            roles: [mystake_common_sdk_1.Roles.ADMIN],
        },
    ],
};
const fakeAddress = {
    careOf: faker.name.firstName(),
    line2: faker.random.alphaNumeric(),
    street: faker.address.streetName(),
    locality: faker.address.city(),
    state: faker.address.stateAbbr(),
    postcode: faker.address.zipCode(),
    country: faker.address.country(),
};
function generateFakeShareholder() {
    return {
        _id: faker.random.alphaNumeric(20),
        shareholderIdentificationNumber: faker.random.alphaNumeric(12),
        entityType: Object.values(mystake_validator_public_1.EntityType)[faker.random.number({ min: 0, max: 3 })],
        trusteeType: Object.values(mystake_validator_public_1.TrusteeType)[faker.random.number({ min: 0, max: 3 })],
        legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
        shares: faker.random.number(),
        stake: faker.random.number(),
        totalPaid: faker.random.number(),
        fullyPaid: faker.random.boolean() ? "Yes" : "No",
        dateFirstEntry: faker.date.past().toISOString(),
    };
}
function generateFakeNotesData() {
    return {
        type: ["convertible", "safe", "custom"][faker.random.number({ min: 0, max: 2 })],
        name: faker.random.alphaNumeric(),
        faceValue: faker.random.number({ min: 0, max: 1000000 }),
        code: faker.random.word(),
        _id: faker.random.uuid(),
        amountIssued: faker.random.number(),
        status: ["issue", "converted", "paid"][faker.random.number({ min: 0, max: 2 })],
    };
}
function generateFakeFundraiseData() {
    const index = faker.random.number({ min: 0, max: 1 });
    return [
        {
            _id: faker.random.uuid(),
            shareClassCode: ["ORD", "PREF"][index],
            shareClassName: ["ORDINARY", "PREFERRED"][index],
            name: faker.random.alphaNumeric(),
            fundraiseCode: faker.random.word(),
            goal: faker.random.number({ min: 0, max: 1000000 }),
            offered: faker.random.number({ min: 0, max: 7000000 }),
            issued: faker.random.number({ min: 0, max: 9000000 }),
            openDate: faker.date.past(10).toISOString(),
            customerAccountName: faker.random.word(),
            customerAccountBSB: faker.random.alphaNumeric(6),
            customerAccountNumber: faker.random.alphaNumeric(12),
        },
    ];
}
function generateFakeHoldings() {
    const index = faker.random.number({ min: 0, max: 1 });
    return [
        {
            shareClass: ["ORDINARY", "PREFERRED"][index],
            shareClassCode: ["ORD", "PREF"][index],
            shareClassId: ["shareclass-5f9b1b1b1b1b1b1b1b1b1b1b", "shareclass-6f9b1b1b1b1b1b1b1b1b1b1b"][index],
            shares: faker.random.number(),
            stake: faker.random.number(),
            pricePerShare: faker.random.number(),
            currentValue: faker.random.number(),
        },
    ];
}
function generateFakeCompanyTransactions() {
    const index = faker.random.number({ min: 0, max: 1 });
    const transaction = {
        _id: faker.random.uuid(),
        date: faker.date.past(),
        shares: faker.random.number(),
        beneficialOwner: faker.random.boolean(),
        isTrustOrSMSF: faker.random.boolean(),
        pricePerShare: faker.random.number(),
        investorType: [mystake_validator_public_1.InvestorType.SOPHISTICATED, mystake_validator_public_1.InvestorType.CROWD_SOURCED][index],
        acn: `${faker.random.number({ min: 111111111, max: 999999999 })}`,
        totalPaid: faker.random.number(),
        name: faker.name.firstName().toString(),
        shareClassCode: ["ORD", "PREF"][index],
        type: ["Buy", "Sell"][index],
        shareClass: ["ORDINARY", "PREFERRED"][index],
        totalUnPaid: faker.random.number(),
        address: [],
        owners: [
            {
                address: Object.assign({}, fakeAddress),
            },
        ],
        taxFileNumber: "111 111 111",
        shareholderId: faker.random.alphaNumeric(20),
        contacts: [
            {
                _id: faker.random.alphaNumeric(20),
                userId: faker.random.alphaNumeric(20),
                firstName: faker.name.firstName(),
                secondName: faker.name.firstName(),
                thirdName: "",
                familyName: faker.name.lastName(),
                email: faker.internet.email(),
                lastLogin: new Date(),
                invitationSentDate: new Date(),
                iso2Code: "",
                dialCode: "",
                phoneNumber: "",
            },
        ],
    };
    return transaction;
}
function generateFakeTransactions() {
    const index = faker.random.number({ min: 0, max: 1 });
    return {
        date: faker.date.past(),
        type: ["WHOLESALE", "RETAIL", "CSF", "OTHER"][faker.random.number({ min: 0, max: 3 })],
        shareClass: ["ORDINARY", "PREFERRED"][index],
        shareClassCode: ["ORD", "PREF"][index],
        shares: faker.random.number(),
        pricePerShare: faker.random.number({ min: 1, max: 100 }),
        totalPaid: faker.random.number(),
        totalUnPaid: faker.random.number(),
    };
}
function generateFakeInvestorDetails() {
    return {
        _id: faker.random.alphaNumeric(20),
        entityType: Object.values(mystake_validator_public_1.EntityType)[faker.random.number({ min: 0, max: 3 })],
        trusteeType: Object.values(mystake_validator_public_1.TrusteeType)[faker.random.number({ min: 0, max: 3 })],
        contactPersonCount: 1,
        legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
        contact: {
            _id: faker.random.alphaNumeric(20),
            userId: faker.random.alphaNumeric(20),
            firstName: faker.name.firstName(),
            secondName: faker.name.firstName(),
            thirdName: "",
            familyName: faker.name.lastName(),
            email: faker.internet.email(),
        },
        lastLogin: faker.date.past(),
    };
}
function generateFakeContactDetails() {
    return {
        _id: faker.random.alphaNumeric(20),
        entityType: Object.values(mystake_validator_public_1.EntityType)[faker.random.number({ min: 0, max: 3 })],
        trusteeType: Object.values(mystake_validator_public_1.TrusteeType)[faker.random.number({ min: 0, max: 3 })],
        contactPersonCount: 1,
        legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
        contact: {
            _id: faker.random.alphaNumeric(20),
            userId: faker.random.alphaNumeric(20),
            firstName: faker.name.firstName(),
            secondName: faker.name.firstName(),
            thirdName: "",
            familyName: faker.name.lastName(),
            email: faker.internet.email(),
            phone: {
                dialCode: "+91",
                phoneNumber: "9999999999",
            },
        },
        name: `${faker.name.prefix()}${faker.name.firstName()}${faker.name.lastName()}`,
    };
}
function generateEntityData() {
    return {
        email: faker.internet.email(),
        address: `${faker.address.streetName()} ${faker.address.city()} ${faker.address.county()}`,
        phoneNumber: faker.phone.phoneNumber(),
        dateOfFirstEntry: faker.date.past().toISOString(),
    };
}
function generateIndividualShareholder() {
    return Object.assign({ name: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}` }, generateEntityData());
}
function generateIndividualTrustee() {
    return Object.assign({ contact: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}` }, generateEntityData());
}
class CompanyServiceStub {
    addPaymentMethod(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    nameOnCard, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cardNumber, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    expiry, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cvv, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isPlanPaid) {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.boolean()
                ? {
                    status: true,
                    message: "Successfully added payment method",
                    payload: null,
                }
                : {
                    status: false,
                    message: "Failed to add payment method",
                    payload: null,
                };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addCompany(companyData) {
        return __awaiter(this, void 0, void 0, function* () {
            // Prefill data
            return {
                status: true,
                message: "Company successfully created",
                payload: null,
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setSelectedPlan(companyId, selectedPlanId) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                message: "Successfully added payment method",
                payload: null,
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cancelCompanyCreation(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                message: "Company removed successfully",
                payload: null,
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateLastAccess(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                message: "Company last access successfully updated",
                payload: null,
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getCompanies(search = "", active = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const resultCount = faker.random.number({ min: 2, max: 5 });
            const data = [];
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < resultCount; i++) {
                data.push({
                    name: faker.company.companyName(),
                    acn: `${faker.random.number({ min: 111111111, max: 999999999 })}`,
                    status: [
                        mystake_common_sdk_1.CompanyListItemStatus.ReadyForReview,
                        mystake_common_sdk_1.CompanyListItemStatus.KYCPending,
                        mystake_common_sdk_1.CompanyListItemStatus.SetUpInProgress,
                        mystake_common_sdk_1.CompanyListItemStatus.AddPaymentMethod,
                    ][faker.random.number({ min: 0, max: 3 })],
                    companyId: faker.random.alphaNumeric(16),
                    lastAccessed: (0, moment_1.default)(faker.date.past()).format("DD/MM/YYYY"),
                });
            }
            return {
                status: true,
                payload: data,
                message: "",
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getCompanyInfo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "",
                    payload: fakeCompanyInfo,
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Company not found",
                        payload: null,
                    });
        });
    }
    getCompanyByAcn(acn) {
        return __awaiter(this, void 0, void 0, function* () {
            if (acn) {
                return {
                    status: true,
                    message: "",
                    payload: fakeCompanyInfo._id,
                };
            }
            return {
                status: false,
                message: "Company not found",
                payload: null,
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAdminInfo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "",
                    payload: fakeUserProfile,
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Admin not found",
                        payload: null,
                    });
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateAuthorizer(companyId, nomineeRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "Successfully Nominated for KYC",
                    payload: null,
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Failed to nominate for KYC",
                    });
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    unsetKYCAuthorizationDetails(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "Successfully unset kyc authorization details",
                    payload: null,
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Failed to unset kyc authorization details",
                    });
        });
    }
    updateCompanyAuthorizationDetails(updateCompanyAuthorizationDetailsBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (updateCompanyAuthorizationDetailsBody) {
                return {
                    status: true,
                    payload: null,
                    message: "company status changed",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error changing company authorization",
            };
        });
    }
    getAllTransactions(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                const transactions = Array.from({
                    length: 30,
                }).map(() => generateFakeCompanyTransactions());
                return {
                    status: true,
                    payload: transactions,
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getCompanyRegister(companyId, keyword, activeClassId, page, rowsPerPage, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortBy, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const count = faker.random.number({ min: 150, max: 280 });
            const tabCount = faker.random.number({ min: 1, max: 2 });
            const data = [];
            for (let i = 0; i < (rowsPerPage < count ? rowsPerPage : count); i += 1) {
                data.push(generateFakeShareholder());
            }
            return {
                status: false,
                payload: {
                    classes: tabCount === 1
                        ? [
                            {
                                _id: faker.random.uuid(),
                                name: "Oridinary",
                                shareClassCode: "ORD",
                            },
                        ]
                        : [
                            {
                                _id: faker.random.uuid(),
                                name: "Oridinary",
                                shareClassCode: "ORD",
                            },
                            {
                                _id: faker.random.uuid(),
                                name: "Preferred",
                                shareClassCode: "PREF",
                            },
                        ],
                    count,
                    data,
                },
                message: "",
            };
        });
    }
    getShareholderDetails(companyId, shareholderId, entityType, trusteeType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholderId && companyId) {
                const shareHolding = {
                    entityDetail: {
                        entityType,
                        entities: [],
                    },
                    holdings: generateFakeHoldings(),
                    transactions: Array.from({
                        length: 5,
                    }).map(() => generateFakeTransactions()),
                    transactionCount: faker.random.number(1000),
                    notesTransactions: [generateFakeNotesData()],
                };
                if (entityType === mystake_validator_public_1.EntityType.JOINT) {
                    shareHolding.entityDetail.entities = Array.from({
                        length: 3,
                    }).map(() => generateIndividualShareholder());
                }
                else if (entityType === mystake_validator_public_1.EntityType.COMPANY) {
                    shareHolding.entityDetail = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: [
                            Object.assign({ acn: faker.random.number().toString(), contact: `${faker.name.firstName()} ${faker.name.lastName()}` }, generateEntityData()),
                        ],
                    };
                }
                else if (entityType === mystake_validator_public_1.EntityType.TRUST || entityType === mystake_validator_public_1.EntityType.SMSF) {
                    if (trusteeType === mystake_validator_public_1.TrusteeType.COMPANY) {
                        shareHolding.entityDetail = {
                            legalEntityName: faker.name.title(),
                            entityType,
                            entities: [
                                Object.assign({ trustAbn: faker.random.number().toString(), trusteeAcn: faker.random.number().toString(), contact: `${faker.name.firstName()} ${faker.name.lastName()}` }, generateEntityData()),
                            ],
                        };
                    }
                    else if (trusteeType === mystake_validator_public_1.TrusteeType.INDIVIDUAL) {
                        shareHolding.entityDetail = {
                            legalEntityName: faker.name.title(),
                            entityType,
                            entities: Array.from({
                                length: 3,
                            }).map(() => generateIndividualTrustee()),
                        };
                    }
                }
                else {
                    shareHolding.entityDetail.entities = Array.from({
                        length: 1,
                    }).map(() => generateIndividualShareholder());
                }
                return {
                    status: true,
                    payload: shareHolding,
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getAllTransactionsByShareholderId(companyId, shareholderId, sortBy, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareholderId && sortBy && sortOrder) {
                const transactions = Array.from({
                    length: 30,
                }).map(() => generateFakeTransactions());
                return {
                    status: true,
                    payload: transactions,
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getShareholderTransactionsByAuctionId({ companyId, shareholderId, auctionId, sortBy, sortOrder, page, rowsPerPage, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareholderId && auctionId && sortBy && sortOrder && page && rowsPerPage) {
                const transactions = Array.from({
                    length: 30,
                }).map(() => generateFakeTransactions());
                return {
                    status: true,
                    payload: { transactions, count: 30 },
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    issueSharesToNewShareholder(companyId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholder && companyId) {
                return {
                    status: true,
                    payload: { shareholderId: faker.random.uuid() },
                    message: "Successfully added shareholder",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    createInvestorProfile(companyId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholder && companyId) {
                return {
                    status: true,
                    payload: { shareholderId: faker.random.uuid() },
                    message: "Successfully created investor profile",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    updateInvestorProfile(companyId, shareholder, overrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareholder && overrides) {
                return {
                    status: true,
                    payload: { shareholderId: faker.random.uuid() },
                    message: "Successfully updated investor profile",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    cloneInvestorRequests(targetCompanyId, investors) {
        return __awaiter(this, void 0, void 0, function* () {
            if (targetCompanyId && investors) {
                return {
                    status: true,
                    payload: null,
                    message: "Successfully cloned investor requests",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    updateShareholder(companyId, shareholderId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholder && companyId && shareholderId) {
                return {
                    status: true,
                    payload: null,
                    message: "Successfully updated shareholder",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    transferSharesToExistingShareholder(companyId, fromShareholderId, toShareholderId, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && fromShareholderId && toShareholderId && transaction) {
                return {
                    status: true,
                    payload: null,
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    transferSharesToNewShareholder(companyId, fromShareholderId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && fromShareholderId && shareholder) {
                return {
                    status: true,
                    payload: null,
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getSharePriceHistory(companyId, sortBy, sortOrder, filterByShareClass) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && sortBy && sortOrder && filterByShareClass) {
                const shareClasses = [
                    {
                        shareClassId: faker.random.uuid(),
                        name: "ORDINARY",
                        shareClassCode: "ORD",
                    },
                    {
                        shareClassId: faker.random.uuid(),
                        name: "PREFERRED",
                        shareClassCode: "PREF",
                    },
                    { shareClassId: faker.random.uuid(), name: "A", shareClassCode: "A" },
                    { shareClassId: faker.random.uuid(), name: "B", shareClassCode: "B" },
                    { shareClassId: faker.random.uuid(), name: "C", shareClassCode: "C" },
                ];
                const sharePriceLogs = [];
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < shareClasses.length * faker.random.number(20); i++) {
                    sharePriceLogs.push({
                        _id: faker.random.uuid(),
                        dateOfUpdate: faker.date.recent(300),
                        shareClass: shareClasses[faker.random.number(4)],
                        sharePrice: faker.random.number(),
                        actionedByUser: {
                            userId: faker.random.uuid(),
                            firstName: faker.random.word(),
                            familyName: faker.random.word(),
                            secondName: faker.random.word(),
                            thirdName: faker.random.word(),
                        },
                    });
                }
                return {
                    status: true,
                    message: "Share Price History",
                    payload: { shareClasses, sharePriceLogs },
                };
            }
            return {
                status: false,
                message: "Invalid request",
                payload: null,
            };
        });
    }
    createNewShareClass(companyId, createNewShareClassData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && createNewShareClassData) {
                return {
                    status: true,
                    payload: null,
                    message: "New share class created successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error creating new share class",
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getShareStructure(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = [];
            const shareClassIndex = faker.random.number({ min: 0, max: 1 });
            const shareClassStructure = {
                shareClassId: faker.random.alphaNumeric(8),
                shareClassName: ["Ordinary", "Preferred"][shareClassIndex],
                shareClassCode: ["Ord", "Pref"][shareClassIndex],
                pricePerShare: faker.random.number({ min: 100, max: 10000 }),
                sharesQuantity: faker.random.number({ min: 1000, max: 10000 }),
                sharesValue: 0,
                effectiveFrom: (0, moment_1.default)(faker.date.recent(faker.random.number({ min: 1, max: 27 }))).toDate(),
            };
            shareClassStructure.sharesValue = shareClassStructure.pricePerShare * shareClassStructure.sharesQuantity;
            data.push(shareClassStructure);
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "",
                    payload: data,
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Unable to fetch share class structure",
                        payload: null,
                    });
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isCapitalStructureAndRegisterDifferent(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.boolean();
        });
    }
    getShareCapitalStructure(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                const companyRegister = {
                    shareClassTitle: faker.random.alphaNumeric(5),
                    shareClassCode: faker.random.alphaNumeric(4),
                    totalSharesIssued: faker.random.number(5),
                    totalAmountPaid: faker.random.number(5),
                    totalAmountUnpaid: faker.random.number(5),
                };
                return {
                    status: true,
                    payload: [companyRegister],
                    message: "Success",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed",
            };
        });
    }
    getCapitalStructureAndRegisterDifference(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                const shareClassAggregate = {
                    shareClassTitle: faker.random.alphaNumeric(5),
                    shareClassCode: faker.random.alphaNumeric(4),
                    totalSharesIssued: faker.random.number(5),
                    totalAmountPaid: faker.random.number(5),
                    totalAmountUnpaid: faker.random.number(5),
                };
                const result = {
                    isCapitalStructureDifferent: faker.random.boolean(),
                    capitalStructure: [
                        Object.assign({}, shareClassAggregate),
                    ],
                    companyRegister: [Object.assign(Object.assign({}, shareClassAggregate), { match: faker.random.boolean() })],
                    dateDataFetched: faker.date.past(),
                };
                return {
                    status: true,
                    payload: result,
                    message: "Success",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed",
            };
        });
    }
    setSharePrice(companyId, shareClassId, setSharePriceRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareClassId && setSharePriceRequestBody) {
                return {
                    status: true,
                    payload: null,
                    message: "Share price updated successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to set the share price",
            };
        });
    }
    getAdminViewInfo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                const roles = ["dir", "sec"];
                const officeholdersByRoles = new Array(faker.random.number(2));
                const officeholders = new Array(faker.random.number(5));
                const activityTypes = Object.values(enums_1.ActivityType);
                const activitySubTypes = Object.values(enums_1.ActivitySubType);
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < officeholdersByRoles.length; i++) {
                    // eslint-disable-next-line no-plusplus
                    for (let j = 0; j < officeholders.length; j++) {
                        officeholders.push({
                            salutation: "Mr.",
                            familyName: faker.name.lastName(),
                            firstName: faker.name.firstName(),
                            role: roles[i],
                            dateOfAppointment: faker.date.past(),
                        });
                    }
                    officeholdersByRoles.push({
                        _id: roles[i],
                        officeholders,
                    });
                }
                return {
                    status: true,
                    message: "Admin view info",
                    payload: {
                        _id: faker.random.uuid(),
                        name: faker.company.companyName(),
                        acn: faker.random.number({ min: 100000000, max: 1000000000 }).toString(),
                        abn: faker.random.number({ min: 10000000000, max: 100000000000 }).toString(),
                        registeredAddress: fakeAddress,
                        principalPlaceOfBusinessAddress: fakeAddress,
                        totalQuantityOfAllShareClasses: faker.random.number(),
                        enterpriseValue: faker.random.number(),
                        officeholdersByRoles,
                        shareClasses: [
                            {
                                name: "ORDINARY",
                                shareClassCode: "ORD",
                                totalQuantity: 20000,
                                totalPaid: 200404220,
                                totalUnpaid: 223494,
                                currentSharePrice: 200,
                                dateLastUpdated: faker.date.past(),
                            },
                        ],
                        topTenShareholders: [
                            {
                                _id: faker.random.uuid(),
                                legalEntityName: faker.company.companyName(),
                                totalSharesOwned: faker.random.number(),
                            },
                        ],
                        recentActivityLogs: [
                            {
                                _id: faker.random.uuid(),
                                companyId: faker.random.uuid(),
                                activityType: activityTypes[faker.random.number(activityTypes.length) - 1],
                                activitySubType: activitySubTypes[faker.random.number(activitySubTypes.length - 1)],
                                activityDescription: faker.random.words(20),
                                dateOfAction: faker.date.recent(),
                                actionedByUser: {
                                    userId: faker.random.uuid(),
                                    familyName: faker.name.lastName(),
                                    firstName: faker.name.firstName(),
                                    secondName: "",
                                    thirdName: "",
                                },
                            },
                        ],
                        nominee: { fullName: "John Smith", email: "john@mail.com" },
                    },
                };
            }
            return { status: false, message: "Invalid request", payload: null };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getCompanyInformationPageData(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = {
                acn: faker.random.number({ min: 100000000, max: 999999999 }).toString(),
                abn: faker.random.number({ min: 10000000000, max: 99999999999 }).toString(),
                name: faker.company.companyName(),
                registeredAddress: {
                    careOf: "",
                    line2: "1",
                    street: faker.address.streetName(),
                    locality: faker.address.city(),
                    state: ["QLD", "VIC", "ACT", "NSW", "NT", "SA", "WA"][faker.random.number({ min: 0, max: 6 })],
                    postcode: faker.random.number({ min: 1000, max: 9999 }).toString(),
                    country: "AU",
                },
                principalPlaceOfBusinessAddress: {
                    careOf: "",
                    line2: "1",
                    street: faker.address.streetName(),
                    locality: faker.address.city(),
                    state: ["QLD", "VIC", "ACT", "NSW", "NT", "SA", "WA"][faker.random.number({ min: 0, max: 6 })],
                    postcode: faker.random.number({ min: 1000, max: 9999 }).toString(),
                    country: "AU",
                },
                shareClasses: [],
                officeholders: [],
                primaryAdminEmail: faker.internet.email(),
                companyContactEmail: faker.internet.email(),
            };
            const index = faker.random.number({ min: 0, max: 1 });
            const shareClassInformation = {
                name: ["ORDINARY", "PREFERRED"][index],
                shareClassCode: ["ORD", "PREF"][index],
                pricePerShare: faker.random.number({ min: 100, max: 10000 }),
                effectiveFrom: (0, moment_1.default)(faker.date.recent(faker.random.number({ min: 1, max: 27 }))).toDate(),
            };
            data.shareClasses.push(shareClassInformation);
            const officeHoldersInformation = {
                roles: [
                    {
                        role: ["Company Secretary", "Director"][faker.random.number({ min: 0, max: 1 })],
                        dateOfAppointment: (0, moment_1.default)(faker.date.recent(faker.random.number({ min: 1, max: 27 }))).toDate(),
                    },
                ],
                firstName: faker.name.firstName(),
                secondName: faker.name.firstName(),
                thirdName: faker.name.firstName(),
                familyName: faker.name.lastName(),
            };
            data.officeholders.push(officeHoldersInformation);
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "",
                    payload: data,
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Unable to fetch share class information",
                        payload: null,
                    });
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAdminList(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = [
                {
                    _id: faker.random.uuid(),
                    userId: faker.random.uuid(),
                    username: faker.random.uuid(),
                    firstName: faker.name.firstName(),
                    secondName: faker.name.firstName(),
                    thirdName: faker.name.firstName(),
                    familyName: faker.name.lastName(),
                    email: faker.internet.email(),
                    lastActivity: "",
                    invitationSentDate: faker.date.past(),
                },
            ];
            return Promise.resolve({
                status: true,
                message: "",
                payload: data,
            });
        });
    }
    addNewAdmin(companyId, addNewAdminRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && addNewAdminRequestBody) {
                return {
                    status: true,
                    payload: null,
                    message: "Admin successfully invited",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to invite new admin",
            };
        });
    }
    resendAdminInvite(companyId, adminUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && adminUserId) {
                return {
                    status: true,
                    payload: null,
                    message: "Admin invitation re-sent successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to resend admin invitation",
            };
        });
    }
    removeAdmin(companyId, adminUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && adminUserId) {
                return {
                    status: true,
                    payload: null,
                    message: "Admin deleted successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to remove admin",
            };
        });
    }
    getShareholders(companyId, keyword = "") {
        return __awaiter(this, void 0, void 0, function* () {
            if (keyword && companyId) {
                const resultCount = faker.random.number({ min: 2, max: 20 });
                const data = Array.from({ length: resultCount }, () => ({
                    _id: faker.random.uuid(),
                    entityType: mystake_validator_public_1.EntityType.JOINT,
                    abn: "",
                    acn: "",
                    legalEntityName: `Shareholder${resultCount}`,
                    legalEntityAddresses: Array.from({ length: resultCount }, () => ({
                        street: faker.address.streetName(),
                        locality: faker.address.county(),
                        state: faker.address.state(),
                        postcode: faker.address.zipCode(),
                        country: faker.address.country(),
                    })),
                    contacts: Array.from({ length: resultCount }, () => ({
                        salutation: faker.name.prefix(),
                        familyName: faker.name.lastName(),
                        firstName: faker.name.firstName(),
                        email: faker.internet.email(),
                        iso2Code: faker.address.countryCode(),
                        dialCode: faker.address.countryCode(),
                        phoneNumber: faker.phone.phoneNumber(),
                    })),
                    holdings: Array.from({ length: resultCount }, () => ({
                        shareClassId: faker.random.uuid(),
                        shareClass: faker.random.word(),
                        pricePerShare: faker.random.number({ min: 10, max: 1000 }),
                        shares: faker.random.number({ min: 10, max: 1000 }),
                        totalPaid: faker.random.number({ min: 100, max: 10000 }),
                        totalUnpaid: faker.random.number({ min: 100, max: 10000 }),
                    })),
                }));
                return {
                    status: true,
                    payload: data,
                    message: "",
                };
            }
            return {
                status: true,
                payload: [],
                message: "",
            };
        });
    }
    getShareholdersV2(companyId, keyword = "") {
        return __awaiter(this, void 0, void 0, function* () {
            if (keyword && companyId) {
                return {
                    status: true,
                    payload: [],
                    message: "",
                };
            }
            return {
                status: true,
                payload: [],
                message: "",
            };
        });
    }
    getShareholdersByTypeAndShareClass(companyId, keyword, shareClassId, investorTypes, sortBy, sortOrder, page, rowsPerPage, sharesInputType, maxSharesTradable, deniedShareholders, activeStatus, auctionShareholderIds) {
        return __awaiter(this, void 0, void 0, function* () {
            if (keyword &&
                companyId &&
                shareClassId &&
                investorTypes &&
                sortBy &&
                sortOrder &&
                page &&
                rowsPerPage &&
                sharesInputType &&
                maxSharesTradable &&
                deniedShareholders &&
                activeStatus &&
                auctionShareholderIds) {
                return {
                    status: true,
                    payload: {
                        shareholders: [],
                        count: 0,
                        allShareholders: [],
                    },
                    message: "",
                };
            }
            return {
                status: true,
                payload: {
                    shareholders: [],
                    count: 0,
                    allShareholders: [],
                },
                message: "",
            };
        });
    }
    getShareholder(companyId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholderId && companyId) {
                return {
                    status: true,
                    payload: {},
                    message: "",
                };
            }
            return {
                status: true,
                payload: {},
                message: "",
            };
        });
    }
    issueSharesToExistingShareholder(companyId, shareholderId, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholderId && companyId && transaction) {
                return {
                    status: true,
                    payload: null,
                    message: "Success",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to delete the admin",
            };
        });
    }
    updateRegisteredAddress(companyId, newRegisteredAddressData, authorisingOfficer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && newRegisteredAddressData && authorisingOfficer) {
                return faker.random.boolean();
            }
            return false;
        });
    }
    updatePrincipalPlaceOfBusinessAddress(companyId, newPrincipalPlaceOfBusinessAddressData, authorisingOfficer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && newPrincipalPlaceOfBusinessAddressData && authorisingOfficer) {
                return faker.random.boolean();
            }
            return false;
        });
    }
    importCSV(companyId, csvFile) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && csvFile) {
                return {
                    status: false,
                    message: "Failed to process CSV",
                    payload: {
                        errorCount: faker.random.number(),
                        errorText: faker.random.words(),
                    },
                };
            }
            return { status: false, message: "Invalid request", payload: null };
        });
    }
    getInvestorInvitations(companyId, keyword, page, rowsPerPage, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && keyword && page && rowsPerPage && sortOrder) {
                const allContactIds = [];
                const investorDetails = Array.from({
                    length: 30,
                }).map(() => {
                    const result = generateFakeInvestorDetails();
                    allContactIds.push(result.contact._id);
                    return result;
                });
                return {
                    status: true,
                    payload: { investorDetails, count: 30, allContactIds },
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    activateAsicConnection(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                payload: null,
                message: "Asic connection activated",
            };
        });
    }
    getAsicConnectionStatus(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                isAsicConnectionActivated: faker.random.boolean(),
                isAgentAuthorized: faker.random.boolean(),
            };
        });
    }
    getCas360ConnectionStatus(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return "connected";
        });
    }
    getTvlConnectionStatus(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return "connected";
        });
    }
    getBgl360AuthoriseUrl(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                payload: "https://www.google.com",
                message: "Success",
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateAsicData(companyId, adminUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                payload: null,
                message: "Asic data updated",
            };
        });
    }
    generateHoldingStatement(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shareholderId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    startDate, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    endDate) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                payload: null,
                message: "Success",
            };
        });
    }
    getCompanyPlanInfo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                const pricePlanInfo = {
                    id: `price_${faker.random.alphaNumeric()}`,
                    productId: `product_${faker.random.alphaNumeric()}`,
                    productName: faker.random.word(),
                    recurringInterval: "month",
                    recurringIntervalCount: 1,
                    trialPeriodDays: faker.random.number(30),
                    amount: faker.random.number(),
                    type: "recurring",
                };
                return {
                    status: true,
                    message: "Company Plan Info",
                    payload: pricePlanInfo,
                };
            }
            return {
                status: false,
                message: "Failed to fetch company plan info",
                payload: null,
            };
        });
    }
    inviteNewShareholder(companyId, inviteNewShareholderRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && inviteNewShareholderRequestBody) {
                return {
                    status: true,
                    payload: null,
                    message: "shareholder successfully invited",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to invite new shareholder",
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getStripeCustomerPortalUrl(companyId, returnPage) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return Promise.resolve({
                    status: false,
                    message: "Stripe customer portal url",
                    payload: "https://www.stripe.com",
                });
            }
            return Promise.reject(new Error("Failed to get Stripe Customer Portal URL"));
        });
    }
    getActivityLogs(companyId, sortBy, sortOrder, skip, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && sortBy && sortOrder && skip && limit) {
                const totalRecordsCount = faker.random.number(10);
                const activityLogs = [];
                const activityTypes = Object.values(enums_1.ActivityType);
                const activitySubTypes = Object.values(enums_1.ActivitySubType);
                for (let index = 0; index < totalRecordsCount; index += 1) {
                    activityLogs.push({
                        _id: faker.random.uuid(),
                        companyId: faker.random.uuid(),
                        activityType: activityTypes[faker.random.number(activityTypes.length) - 1],
                        activitySubType: activitySubTypes[faker.random.number(activitySubTypes.length - 1)],
                        activityDescription: faker.random.words(20),
                        dateOfAction: faker.date.recent(),
                        actionedByUser: {
                            userId: faker.random.uuid(),
                            familyName: faker.name.lastName(),
                            firstName: faker.name.firstName(),
                            secondName: "",
                            thirdName: "",
                        },
                    });
                }
                return {
                    status: true,
                    message: "Company Activity Logs",
                    payload: { count: activityLogs.length, activityLogs },
                };
            }
            return {
                status: false,
                message: "Failed to fetch activity logs",
                payload: null,
            };
        });
    }
    getInvestorContacts(companyId, keyword, page, rowsPerPage, sortOrder, sortBy) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && keyword && page && rowsPerPage && sortOrder && sortBy) {
                const allContactIds = [];
                const shareholderContactDetails = Array.from({
                    length: 30,
                }).map(() => {
                    const result = generateFakeContactDetails();
                    allContactIds.push(result.contact._id);
                    return result;
                });
                const noteholderContactDetails = Array.from({
                    length: 15,
                }).map(() => {
                    const result = generateFakeContactDetails();
                    allContactIds.push(result.contact._id);
                    return result;
                });
                const optionholderContactDetails = Array.from({
                    length: 3,
                }).map(() => {
                    const result = generateFakeContactDetails();
                    allContactIds.push(result.contact._id);
                    return result;
                });
                const contactDetails = [...shareholderContactDetails, ...noteholderContactDetails, ...optionholderContactDetails];
                return {
                    status: true,
                    payload: {
                        contactDetails,
                        shareholderContactDetails,
                        noteholderContactDetails,
                        optionholderContactDetails,
                        count: 48,
                        allContactIds,
                    },
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getAllContacts(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    payload: [],
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    createAnnouncement(companyId, createAnnouncementRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && createAnnouncementRequestBody) {
                return {
                    status: true,
                    payload: null,
                    message: "Successfully sent email announcement",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to send email announcement",
            };
        });
    }
    uploadDocument(companyId, uploadedByUserId, pdfFile, shareholderId, expiryDate) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && pdfFile && uploadedByUserId && shareholderId && expiryDate) {
                return {
                    status: true,
                    message: "Document imported successfully",
                    payload: null,
                };
            }
            return { status: false, message: "Failed import document", payload: null };
        });
    }
    deleteDocument(companyId, documentId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && documentId) {
                return {
                    status: true,
                    message: "Document deleted successfully",
                    payload: null,
                };
            }
            return { status: false, message: "Failed to delete document", payload: null };
        });
    }
    getCompanyDocuments(companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    page, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    rowsPerPage, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortBy, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                const documentList = [
                    {
                        _id: faker.random.uuid(),
                        fileName: faker.random.word(),
                        dateUploaded: faker.date.past(),
                        uploadedByUser: {
                            userId: faker.random.uuid(),
                            firstName: faker.name.firstName(),
                            familyName: faker.name.lastName(),
                        },
                    },
                ];
                return {
                    status: false,
                    message: "Success",
                    payload: { documentList, count: 1 },
                };
            }
            return { status: false, message: "Invalid request", payload: null };
        });
    }
    getShareholderDocuments(companyId, shareholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareholderId) {
                return {
                    status: true,
                    message: "Success",
                    payload: [
                        {
                            _id: faker.random.uuid(),
                            fileName: faker.random.word(),
                            expiryDate: faker.date.future(),
                        },
                    ],
                };
            }
            return { status: false, message: "Failed", payload: null };
        });
    }
    getSignedUrlOfDocument(companyId, documentId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && documentId) {
                return {
                    status: true,
                    message: "Success",
                    payload: faker.internet.url(),
                };
            }
            return { status: false, message: "Failed", payload: null };
        });
    }
    uploadCompanyLogo(companyId, logoFile) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && logoFile) {
                return {
                    status: true,
                    message: "Company logo uploaded successfully",
                    payload: null,
                };
            }
            return {
                status: false,
                message: "Failed to upload company logo",
                payload: null,
            };
        });
    }
    setCompanyDisplayName(companyId, name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && name) {
                return {
                    status: true,
                    message: "Company display name updated successfully",
                    payload: null,
                };
            }
            return {
                status: false,
                message: "Failed to update company display name",
                payload: null,
            };
        });
    }
    deleteTransactionsOfShareholder(companyId, shareholderIds) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareholderIds) {
                return {
                    status: true,
                    message: "Success",
                    payload: null,
                };
            }
            return {
                status: true,
                message: "Failed",
                payload: null,
            };
        });
    }
    deleteTransactionsOfACompany(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    message: "Success",
                    payload: null,
                };
            }
            return {
                status: true,
                message: "Failed",
                payload: null,
            };
        });
    }
    getOfficeholders(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    message: "Success",
                    payload: {
                        DIR: [
                            {
                                _id: "officeholder-id-1",
                                companyId: "id-213",
                                name: { firstName: "First name", familyName: "Family name" },
                                roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                            },
                        ],
                        SEC: [
                            {
                                _id: "officeholder-id-2",
                                companyId: "id-213",
                                name: { firstName: "First name", familyName: "Family name" },
                                roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                            },
                        ],
                    },
                };
            }
            return {
                status: false,
                message: "Success",
                payload: {
                    DIR: [
                        {
                            _id: "officeholder-id-1",
                            companyId: "id-213",
                            name: { firstName: "First name", familyName: "Family name" },
                            roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                        },
                    ],
                    SEC: [
                        {
                            _id: "officeholder-id-2",
                            companyId: "id-213",
                            name: { firstName: "First name", familyName: "Family name" },
                            roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                        },
                    ],
                },
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getOfficeholderById(companyId, officeholderId) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                message: "Success",
                payload: {
                    _id: "officeholder-id-1",
                    companyId: "id-213",
                    name: { firstName: "First name", familyName: "Family name" },
                    roles: [{ dateOfAppointment: new Date(), role: "dir" }],
                },
            };
        });
    }
    removeOfficeholders(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeOfficeholdersRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                message: "Success",
                payload: null,
            };
        });
    }
    appointOfficeholder(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    appointOfficeholderRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                message: "Success",
                payload: null,
            };
        });
    }
    updateOfficeholder(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    companyId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    officeholderId, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    editOfficeholderRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                message: "Success",
                payload: null,
            };
        });
    }
    createNewNotes(companyId, createNotesData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && createNotesData) {
                return {
                    status: true,
                    payload: null,
                    message: "New Notes created successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error creating new Note",
            };
        });
    }
    getAllNotes(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                const fakeNotesData = [generateFakeNotesData()];
                return {
                    status: true,
                    message: "Success",
                    payload: fakeNotesData,
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error getting notes list",
            };
        });
    }
    issueNotesToExistingShareholder(companyId, shareholderId, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholderId && companyId && transaction) {
                return {
                    status: true,
                    payload: null,
                    message: "Success",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to issue note",
            };
        });
    }
    issueNotesToNewShareholder(companyId, shareholder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholder && companyId) {
                return {
                    status: true,
                    payload: { shareholderId: faker.random.uuid() },
                    message: "Successfully issued note to new shareholder",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getNotesRegister(companyId, keyword, activeClassId, page, rowsPerPage, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortBy, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const count = faker.random.number({ min: 150, max: 280 });
            const tabCount = faker.random.number({ min: 1, max: 2 });
            const data = [];
            for (let i = 0; i < (rowsPerPage < count ? rowsPerPage : count); i += 1) {
                data.push({
                    _id: faker.random.uuid(),
                    notesCode: ["CS1", "CN1"],
                    legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
                    dateOfFirstIssue: faker.date.past().toISOString(),
                    totalAmountInvested: faker.random.number(),
                });
            }
            return {
                status: false,
                payload: {
                    codes: tabCount === 1
                        ? [{ _id: faker.random.uuid(), code: "CN1" }]
                        : [
                            { _id: faker.random.uuid(), code: "CN1" },
                            { _id: faker.random.uuid(), code: "CN2" },
                        ],
                    count,
                    data,
                },
                message: "",
            };
        });
    }
    getNotesCsvData(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    payload: [],
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    deleteNote(companyId, notesId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && notesId) {
                return {
                    status: true,
                    payload: null,
                    message: "Note deleted successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to remove note",
            };
        });
    }
    getNotesNamesAndCodes(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    payload: [{ name: "Convertible Employee", code: "CNN1" }],
                    message: "Successfully received note names and codes",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to get note names and codes",
            };
        });
    }
    getOptionGrantDetailsByShareholderId(companyId, shareholderId, optiongrantId, entityType, trusteeType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholderId && companyId) {
                const shareHolding = {
                    entityDetail: {
                        entityType,
                        entities: [],
                    },
                    grantSummary: {
                        grantDate: new Date("2021-10-30T14:00:00.000+00:00"),
                        shareClassCode: ["ORD", "EMP", "TAX"][faker.random.number({ min: 0, max: 2 })],
                        exercisePrice: 260,
                        numberGranted: faker.random.number(10000),
                        numberVested: faker.random.number(1000),
                        numberScheduledToVest: faker.random.number(0),
                        numberExercised: 0,
                        vestingType: ["Time", "Manual"][faker.random.number({ min: 0, max: 1 })],
                        vestingPeriod: faker.random.number(60),
                        cliff: faker.random.number(12),
                        cliffAmount: faker.random.number(2000),
                        vestingFrequency: faker.random.number(10),
                        lastExerciseDate: new Date("2023-12-30T14:00:00.000+00:00"),
                        lastVestingDate: new Date("2023-10-30T14:00:00.000+00:00"),
                    },
                };
                if (entityType === mystake_validator_public_1.EntityType.JOINT) {
                    shareHolding.entityDetail.entities = Array.from({
                        length: 3,
                    }).map(() => generateIndividualShareholder());
                }
                else if (entityType === mystake_validator_public_1.EntityType.COMPANY) {
                    shareHolding.entityDetail = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: [
                            Object.assign({ acn: faker.random.number().toString(), contact: `${faker.name.firstName()} ${faker.name.lastName()}` }, generateEntityData()),
                        ],
                    };
                }
                else if (entityType === mystake_validator_public_1.EntityType.TRUST || entityType === mystake_validator_public_1.EntityType.SMSF) {
                    if (trusteeType === mystake_validator_public_1.TrusteeType.COMPANY) {
                        shareHolding.entityDetail = {
                            legalEntityName: faker.name.title(),
                            entityType,
                            entities: [
                                Object.assign({ trustAbn: faker.random.number().toString(), trusteeAcn: faker.random.number().toString(), contact: `${faker.name.firstName()} ${faker.name.lastName()}` }, generateEntityData()),
                            ],
                        };
                    }
                    else if (trusteeType === mystake_validator_public_1.TrusteeType.INDIVIDUAL) {
                        shareHolding.entityDetail = {
                            legalEntityName: faker.name.title(),
                            entityType,
                            entities: Array.from({
                                length: 3,
                            }).map(() => generateIndividualTrustee()),
                        };
                    }
                }
                else {
                    shareHolding.entityDetail.entities = Array.from({
                        length: 1,
                    }).map(() => generateIndividualShareholder());
                }
                return {
                    status: true,
                    payload: shareHolding,
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    getOptionUnitsDetailsByGrantId(companyId, shareholderId, optiongrantId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholderId && companyId && optiongrantId) {
                return {
                    status: true,
                    payload: [
                        {
                            _id: "123",
                            vestingDate: new Date("2020-10-10T14:00:00.000+00:00"),
                            numberGranted: faker.random.number(1000),
                            firstExercisedDate: new Date("2021-05-16T14:00:00.000+00:00"),
                            numberExercised: faker.random.number(1000),
                        },
                        {
                            _id: "345",
                            vestingDate: new Date("2021-10-10T14:00:00.000+00:00"),
                            numberGranted: 625,
                            numberExercised: 0,
                        },
                    ],
                    message: "",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    // eslint-disable-next-line consistent-return
    getNoteDetailsByShareholderId(companyId, shareholderId, notetransactionId, entityType, trusteeType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shareholderId && companyId && notetransactionId) {
                const noteHolding = {
                    entityDetails: {
                        entityType,
                        entities: [],
                    },
                    noteDetails: generateFakeNotesData(),
                };
                if (entityType === mystake_validator_public_1.EntityType.JOINT) {
                    noteHolding.entityDetails.entities = Array.from({
                        length: 3,
                    }).map(() => generateIndividualShareholder());
                }
                else if (entityType === mystake_validator_public_1.EntityType.COMPANY) {
                    noteHolding.entityDetails = {
                        legalEntityName: faker.name.title(),
                        entityType,
                        entities: [
                            Object.assign({ acn: faker.random.number().toString(), contact: `${faker.name.firstName()} ${faker.name.lastName()}` }, generateEntityData()),
                        ],
                    };
                }
                else if (entityType === mystake_validator_public_1.EntityType.TRUST || entityType === mystake_validator_public_1.EntityType.SMSF) {
                    if (trusteeType === mystake_validator_public_1.TrusteeType.COMPANY) {
                        noteHolding.entityDetails = {
                            legalEntityName: faker.name.title(),
                            entityType,
                            entities: [
                                Object.assign({ trustAbn: faker.random.number().toString(), trusteeAcn: faker.random.number().toString(), contact: `${faker.name.firstName()} ${faker.name.lastName()}` }, generateEntityData()),
                            ],
                        };
                    }
                    else if (trusteeType === mystake_validator_public_1.TrusteeType.INDIVIDUAL) {
                        noteHolding.entityDetails = {
                            legalEntityName: faker.name.title(),
                            entityType,
                            entities: Array.from({
                                length: 3,
                            }).map(() => generateIndividualTrustee()),
                        };
                    }
                }
                else {
                    noteHolding.entityDetails.entities = Array.from({
                        length: 1,
                    }).map(() => generateIndividualShareholder());
                }
                return {
                    status: true,
                    payload: noteHolding,
                    message: "",
                };
            }
        });
    }
    createNewOptionsPool(companyId, createNewOptionsPoolData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (createNewOptionsPoolData && companyId) {
                return {
                    status: true,
                    payload: null,
                    message: "New Options pool created successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    convertNotes(companyId, shareholderId, notesId, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareholderId && notesId && transaction) {
                return {
                    status: true,
                    payload: null,
                    message: "Successfully converted note",
                };
            }
            return {
                status: false,
                payload: null,
                message: "",
            };
        });
    }
    updateOptionsPool(companyId, optionsPoolId, updateOptionsPoolData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (updateOptionsPoolData && companyId && optionsPoolId) {
                return {
                    status: true,
                    payload: null,
                    message: "New Options pool updated successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error updating options pool",
            };
        });
    }
    removeOptionsPool(companyId, optionsPoolId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && optionsPoolId) {
                return {
                    status: true,
                    payload: null,
                    message: "Options pool deleted successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error deleting options pool",
            };
        });
    }
    getOptionPoolNames(companyId, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const numberOfPools = type === OptionGrantType_1.OptionGrantsType.EMPLOYEE ? 4 : 8;
            const fakeData = Array(numberOfPools).map(() => ({
                _id: faker.random.uuid(),
                name: faker.random.word(),
                code: ["OPT1", "OPT2"][faker.random.number({ min: 0, max: 1 })],
                shareClass: {
                    _id: faker.random.uuid(),
                    name: faker.random.word(),
                    shareClassCode: faker.random.alphaNumeric(4),
                    defaultExercisePrice: faker.random.number(20),
                },
            }));
            return {
                status: true,
                payload: fakeData,
                message: "Successfully retrieved option pool names",
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getOptionPools(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const fakeData = Array.from({ length: faker.random.number(6) }).map(() => ({
                optiongrantIds: [],
                _id: faker.random.uuid(),
                name: faker.random.word(),
                shareclassId: faker.random.uuid(),
                totalOptions: faker.random.number(1000000),
                createdAt: faker.date.past(),
                updatedAt: faker.date.past(),
                code: faker.random.alphaNumeric(4),
                data: {
                    granted: faker.random.number(1000000),
                    availableToGrant: faker.random.number(1000000),
                    unvested: faker.random.number(1000000),
                    vested: faker.random.number(1000000),
                    exercised: faker.random.number(1000000),
                },
            }));
            return {
                status: true,
                payload: fakeData,
                message: "Successfully retrieved option pool names",
            };
        });
    }
    createNewOptionGrant(companyId, optionGrantData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && optionGrantData) {
                return {
                    status: true,
                    payload: { shareholderId: faker.random.uuid() },
                    message: "Successfully created an option unit",
                };
            }
            return {
                status: false,
                payload: { shareholderId: faker.random.uuid() },
                message: "Failed to create an option unit",
            };
        });
    }
    deleteOptionUnit(companyId, optionUnitId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && optionUnitId) {
                return {
                    status: true,
                    payload: null,
                    message: "The option unit was deleted successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to delete the option uni",
            };
        });
    }
    createOptionUnit(companyId, optionUnitData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && optionUnitData) {
                return {
                    status: true,
                    payload: null,
                    message: "Successfully created an option unit",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error creating an option unit",
            };
        });
    }
    getOptionRegisterForOptionholder() {
        const fakeData = Array(faker.random.number(5)).map(() => ({
            _id: faker.random.uuid(),
            grantDate: faker.date.past(),
            shareClass: {
                _id: faker.random.uuid(),
                name: faker.random.word(),
                shareClassCode: faker.random.alphaNumeric(4),
            },
            exercisePrice: faker.random.number(25),
            numberOfOptions: faker.random.number(1000),
            vested: faker.random.number(200),
            exercised: faker.random.number(200),
            lastExerciseDate: faker.date.future(),
        }));
        return Promise.resolve({
            status: true,
            payload: fakeData,
            message: "Successfully retrieved option pool names",
        });
    }
    getOptionRegister() {
        const fakeData = Array(faker.random.number(6)).map(() => ({
            _id: faker.random.uuid(),
            legalEntityName: faker.random.word(),
            optionCode: ["CS1", "CN1"],
            totalGranted: faker.random.number(),
            totalVested: faker.random.number(),
            totalExercised: faker.random.number(),
            dateOfFirstGrant: faker.date.past(),
        }));
        const pools = Array(faker.random.number(5)).map(() => ({
            _id: faker.random.uuid(),
            name: faker.random.word(),
            code: faker.random.alphaNumeric(4),
        }));
        return Promise.resolve({
            status: true,
            payload: {
                pools,
                data: fakeData,
                count: faker.random.number(fakeData.length * 2),
            },
            message: "Successfully retrieved option pool names",
        });
    }
    getOptionsCsvData() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = [];
            return {
                status: true,
                payload: data,
                message: "Successfully retrieved option csv data",
            };
        });
    }
    getOptionPoolNamesAndCodes(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    payload: [{ name: "Option pool 1", code: "OPN1" }],
                    message: "Successfully received option pools names and codes",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to get option pools names and codes",
            };
        });
    }
    exerciseOptions(companyId, optiongrantId, exerciseData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && optiongrantId && exerciseData) {
                return {
                    status: true,
                    payload: null,
                    message: "Successfully exercised options",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error exercising options",
            };
        });
    }
    updateGrant(companyId, optiongrantId, updateData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && optiongrantId && updateData) {
                return {
                    status: true,
                    payload: null,
                    message: "Successfully updated option grant",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error updating option grant",
            };
        });
    }
    deleteGrant(companyId, optiongrantId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && optiongrantId) {
                return {
                    status: true,
                    payload: null,
                    message: "Successfully deleted option grant",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error deleting option grant",
            };
        });
    }
    generateShareCertificate(companyId, shareholderId, shareCertificateId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareCertificateId && shareholderId) {
                return {
                    status: true,
                    payload: null,
                    message: "Success",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error creating certificate",
            };
        });
    }
    createNewFundraise(companyId, createFundraiseData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && createFundraiseData) {
                return {
                    status: true,
                    payload: null,
                    message: "Fundraise round created successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error creating Fundraise round",
            };
        });
    }
    getFundraiseByFundraiseId(companyId, fundraiseId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && fundraiseId) {
                const fakeFundraiseData = generateFakeFundraiseData();
                return {
                    status: true,
                    message: "Successfully returned Fundraise round",
                    payload: fakeFundraiseData[0],
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error getting fundraise round",
            };
        });
    }
    paySubscriptionAgreement(companyId, paySubscriptionAgreementRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && paySubscriptionAgreementRequestBody) {
                return {
                    status: true,
                    payload: null,
                    message: "Paymemt details successfully sent",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed send payment details",
            };
        });
    }
    generateReconciliationReport(companyId, fundraiseRound, timestamp) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && fundraiseRound && timestamp) {
                return {
                    status: true,
                    payload: null,
                    message: "Reconciliation report successfully generated",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error generating reconciliation report",
            };
        });
    }
    getHighestShareCertificateNumber(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    payload: faker.random.number(),
                    message: "succesfully returned highest certificate number",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error returning highest certificate number",
            };
        });
    }
    getFundraiseCsvDataByFundraiseId(companyId, fundraiseId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && fundraiseId) {
                const data = [];
                const offerAmount = faker.random.number();
                const fees = offerAmount * 0.006;
                data.push({
                    legalEntityName: `${faker.name.prefix()} ${faker.name.firstName()} ${faker.name.lastName()}`,
                    bankReference: "FR00001",
                    shareQuantity: faker.random.number(),
                    offerAmount,
                    paidDate: faker.date.past().toISOString(),
                    fees,
                    amountDeposited: offerAmount - fees,
                });
                return {
                    status: true,
                    payload: data,
                    message: "Fundraise csv data found",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error returning Fundraise csv data",
            };
        });
    }
    createFundraiseBankAccount(companyId, bankAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (bankAccount && companyId) {
                return {
                    status: true,
                    payload: null,
                    message: "Fundraise bank account created successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error creating fundraise bank account",
            };
        });
    }
    getAllInvestors(companyId, keyword, page, rowsPerPage, sortBy, sortOrder, status = [mystake_common_sdk_1.ShareholderStatus.ACCEPTED]) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && keyword && page && rowsPerPage && sortBy && sortOrder && status) {
                const data = {};
                return {
                    status: true,
                    payload: data,
                    message: "Succesfully fetched investors data",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Failed to fetch investors data",
            };
        });
    }
    updateCompanyContactEmail(companyId, email) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && email) {
                return {
                    status: true,
                    payload: null,
                    message: "Company contact email updated successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error updating company contact email",
            };
        });
    }
    setLiquidityProvider(companyId, { shareholderId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareholderId) {
                return {
                    status: true,
                    payload: null,
                    message: "Liquidity provider set successfully",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error setting liquidity provider",
            };
        });
    }
    getLiquidityProvider(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId) {
                return {
                    status: true,
                    payload: null,
                    message: "Succesfully fetched liquidity providers",
                };
            }
            return {
                status: false,
                payload: null,
                message: "Error fetching liquidity providers",
            };
        });
    }
}
exports.CompanyServiceStub = CompanyServiceStub;
//# sourceMappingURL=CompanyServiceStub.js.map